import React from 'react';
import { isSafari, isIE, isChrome, isMobile, isIOS } from 'react-device-detect';

import {prepareWidgetData} from '../../../../helpers/itemizationDataHelper';
import {getCommonChartOptions, getChartSeries} from '../../../../helpers/highchartHelper';
import { PIE_CHART_SIZE,FONT_WEIGHT } from '../../../../constants/common';
import BCLHighchart from '../../../common/Highchart/BCLHighchart';

export default class MonthlySummaryPieChart extends React.Component{
  static getDerivedStateFromProps(props, state) {
    let fuelType = props.fuelType;
    let noData = !props.itemizationData.itemizationDetails[fuelType];
    let widgetData = prepareWidgetData(props.itemizationData.itemizationDetails[fuelType],  props.mode, props.appliancesList);
    if(widgetData.seriesData !== state.seriesData || widgetData.slicedSeriesData !== state.seriesData || widgetData.totalCost !== state.totalCostOrConsumption || props.mode !== state.mode){
      return{
        seriesData : widgetData.seriesData,
        slicedSeriesData : widgetData.slicedSeriesData,
        totalCostOrConsumption : widgetData.totalCostOrConsumption,
        mode : props.mode,
        noData: noData
      }
    }
    return null;
  }

    constructor(props){
        super(props);
        this.state = {
          seriesData: null,
          slicedSeriesData: null,
          totalCostOrConsumption: null,
          mode : null,
          noData : false
        };
      }
    
      afterChartCreated(chart) {
        this.internalChart = chart;
      }

    render(){
        const isMobileChrome = isChrome && isMobile && isIOS;
        const mode = this.state.mode;
        const totalCostOrConsumption = this.state.totalCostOrConsumption;
        const chartHeight = this.state.seriesData.length > 10 ? 500 : 'auto'
        let options = getCommonChartOptions(totalCostOrConsumption, mode, false, this.props.totalText, chartHeight, this.props.fuelType);
        options.responsive= {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              chart:{
                animation : false,
                height : 500
              },
              legend: {
                width: 'auto',
                itemStyle: {
                  fontSize: '12px'
                },
                align: "center",
                verticalAlign: "bottom",
                layout : "horizontal",
                alignColumns: true
              },
              title:{
                x:0,
                y:-70
              },
              subtitle:{
                x:0,
                y: -40
              },
              series : getChartSeries(this.state.slicedSeriesData, this.state.seriesData, this.state.slicedSeriesData, PIE_CHART_SIZE.MEDIUM)
            }
          },
          {
            condition: {
              maxWidth: 350
            },
            chartOptions: {
              chart:{
                animation : false,
                height : 340
              },
              legend: {
                itemStyle: {
                  fontSize: '12px'
                },
                align: "center",
                verticalAlign: "bottom",
                layout : "horizontal",
                alignColumns: true
              },
              title:{
                x:0,
                y:-85
              },
              subtitle:{
                x:0,
                y: -55,
              style:{fontSize: '20px',fontWeight: FONT_WEIGHT.bold}
              },
              series : getChartSeries(this.state.slicedSeriesData, this.state.seriesData, this.state.slicedSeriesData, PIE_CHART_SIZE.SMALL)
            }
          }]
        }
        options.series = getChartSeries(this.state.slicedSeriesData, this.state.seriesData, this.state.slicedSeriesData, PIE_CHART_SIZE.LARGE);
        return(
            <>
                <svg height="0" width="0">
                    <defs>
                        <filter id="blurFilter2" y="-20" height="500" x="-20" width="120">
                        <feOffset in="SourceGraphic" dx="0" dy="0" result="offOut" />
                        <feGaussianBlur in="offOut" stdDeviation="10" result="blur2" />
                        <feMerge>
                            <feMergeNode in="blur2" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                        </filter>
                        <filter id="filter" y="-20" height="500" x="-20" width="150"> <feOffset in="SourceGraphic" dx="0" dy="0"></feOffset> <feGaussianBlur stdDeviation="10" result="DROP"></feGaussianBlur> <feComposite in="DROP" operator="in" result="SHADOW1"></feComposite> <feComponentTransfer in="SHADOW1" result="SHADOW"> <feFuncA type="table" tableValues="0 1.2"></feFuncA> </feComponentTransfer> <feMerge> <feMergeNode in="SHADOW"></feMergeNode> <feMergeNode in="SourceGraphic"></feMergeNode> </feMerge> </filter>
                    </defs>
                </svg>
                <div className={"ms-pie-chart " + (this.state.noData ? (isIE || isSafari) ? "ie-no-data" : "no-data": "") + (!isIE && !isSafari ? " chart-filter" : "")}>
                    {this.state.seriesData !=null ? <BCLHighchart callback={ this.afterChartCreated } options={options} oneToOne={true} updateArgs={[true]}/> : ''}
                </div>
            </>
        )
    }
}